module.exports = __webpack_public_path__ + "static/img/can-orange-cream.717164d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cans/can-orange-cream.png
// module id = laG3
// module chunks = 0